var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[_c('box',{ref:"box",attrs:{"obj":_vm.obj}}),_c('div',{staticClass:"button ta-c"},[_c('Button',{attrs:{"type":"primary","disabled":_vm.obj.toPdf === 0},on:{"click":function($event){return _vm.$refs['box'].getPdf()}}},[_vm._v("下载协议")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }